// Account codes
export const ACCOUNT_CODES = {
  MONEY_IN_TRANSIT: '1999',
  MONEY_IN_TRANSIT_OUTSTANDING: '1998',
} as const;

// Account category IDs
export const ACCOUNT_CATEGORY_IDS = {
  PERSONAL_BUSINESS: '9',
} as const;

// Ledger account category types
export const LEDGER_ACCOUNT_CATEGORY_TYPES = {
  BALANCE_SHEET: 'BALANCE_SHEET',
  INCOME_STATEMENT: 'INCOME_STATEMENT',
} as const;

// Performance constants
export const PERFORMANCE_CONSTANTS = {
  OVERSCAN_COUNT: 5,
  DEFAULT_LINE_HEIGHT: 16,
  BORDER_WIDTH: 1,
  DATA_ENTRY_ROW_PADDING_HEIGHT: 4,
  NOTE_ROW_GAP: 8,
} as const;

// Navigation width constants
export const NAVIGATION_WIDTHS = {
  EXPANDED: 346,
  COLLAPSED: 20,
} as const;
